import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import Layout from '../components/Layout';
import ChatView from '../components/ChatView';
import api from '../lib/api';

export default function AdminChat() {
  const { userId } = useParams();
  const [target, setTarget] = useState(null);

  useEffect(() => {
    api.get('/users').then(({ data }) => {
      const u = data.find(x => x.id === userId);
      setTarget(u);
    }).catch(() => {});
  }, [userId]);

  return (
    <Layout title={target?.username || 'Chat'} showBack backTo="/admin">
      {target && (
        <ChatView
          recipientId={target.id}
          recipientName={target.username}
          recipientOnline={target.is_online}
          recipientLastSeen={target.last_seen}
          recipientAvatarUrl={target.avatar_url}
        />
      )}
    </Layout>
  );
}
